import BedManagementNav from "../../pages/Dashboard/BedManagement/BedManagementNav";
import BedDashboard from "../../pages/Dashboard/BedManagement/BedDashboard";
import WardList from "../../pages/Dashboard/BedManagement/WardList";
import RoomList from "../../pages/Dashboard/BedManagement/RoomList";
import BedList from "../../pages/Dashboard/BedManagement/BedList";

const bedManagementRoutes = {
  path: "/bed-management",
  element: <BedManagementNav />,
  children: [
    { path: "/bed-management", element: <BedDashboard /> },
    { path: "/bed-management/wards", element: <WardList /> },
    { path: "/bed-management/rooms", element: <RoomList /> },
    { path: "/bed-management/beds", element: <BedList /> },
  ],
};

export default bedManagementRoutes;
